import React from "react";
import _ from "lodash";
import { assetsPath } from "../../utils";
import { BackgroundImage } from "../../components";

const baseAssetUrl = assetsPath("laguna-beachside");
const baseAssetVideoUrl = `${baseAssetUrl}/videos`;

// const residencesCommonArea1 = `${baseAssetUrl}/images/gallery/images/residences-common-area/1.jpg`;

// const heroShotImg2_dev = `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/hero-shot/dev-1.jpg`;
// const heroShotImg4_dev = `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/hero-shot/dev-2.jpg`;
// const heroShotImg5_dev = `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/hero-shot/dev-3.jpg`;

const heroShotImg1 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/hero-shot/1.jpg`;
const heroShotImg2 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/hero-shot/2.jpg`;
const heroShotImg3 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/hero-shot/3.jpg`;
const heroShotImg4 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/hero-shot/4.jpg`;
const heroShotImg5 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/hero-shot/5.jpg`;
const heroShotImg6 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/hero-shot/6.jpg`;
const heroShotImg7 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/hero-shot/7.jpg`;
const heroShotImg8 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/hero-shot/8.jpg`;

const destinationLifestyle1 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/destination-lifestyle/1.jpg`;
const destinationLifestyle2 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/destination-lifestyle/2.jpg`;
const destinationLifestyle3 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/destination-lifestyle/3.jpg`;
const destinationLifestyle4 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/destination-lifestyle/4.jpg`;
const destinationLifestyle5 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/destination-lifestyle/5.jpg`;
const destinationLifestyle6 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/destination-lifestyle/6.jpg`;
const destinationLifestyle7 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/destination-lifestyle/7.jpg`;

const residencesAerial1 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-aerial/1.jpg`;
const residencesAerial2 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-aerial/2.jpg`;
const residencesAerial3 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-aerial/3.jpg`;

const residencesCommonArea1 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-common-area/1.jpg`;
const residencesCommonArea2 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-common-area/2.jpg`;

const residencesExterior1 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-exterior/1.jpg`;
const residencesExterior2 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-exterior/2.jpg`;
const residencesExterior3 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-exterior/3.jpg`;
const residencesExterior4 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-exterior/4.jpg`;

const residencesInterior1 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-interior/1.jpg`;
const residencesInterior2 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-interior/2.jpg`;
const residencesInterior3 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-interior/3.jpg`;
const residencesInterior4 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-interior/4.jpg`;
const residencesInterior5 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-interior/5.jpg`;
const residencesInterior6 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-interior/6.jpg`;
const residencesInterior7 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-interior/7.jpg`;
const residencesInterior8 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-interior/8.jpg`;

const residencesLifestyle1 = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/images/residences-lifestyle/1.jpg`;

// const video = {
//   en: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_ENG_w-disclaimer_Comp.mp4`,
//   ru: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_Trilingual_Comp.mp4`,
//   cn: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_Trilingual_Comp.mp4`,
// };
const videoSource = `${assetsPath(
  "laguna-beachside"
)}/images/gallery/video/LBS video.mp4`;
// const video = `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/video/1.jpg`;

const video = {
  en: videoSource,
  ru: videoSource,
  cn: videoSource,
};

const videos = [
  {
    titleKey: "propertyVideo",
    source: {
      en: `${assetsPath(
        "phuket-laguna-park-2"
      )}/video/LP2_2_16x9_EN_Compress.mp4`,
      ru: `${assetsPath(
        "phuket-laguna-park-2"
      )}/video/LP2_2_16x9_EN_Compress.mp4`,
      cn: `${assetsPath(
        "phuket-laguna-park-2"
      )}/video/LP2_2_16x9_EN_Compress.mp4`,
      // en: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_ENG_w-disclaimer_Comp.mp4`,
      // cn: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_Trilingual_Comp.mp4`,
      // ru: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_Trilingual_Comp.mp4`,
    },
    text: {
      en: ["PROPERTY VIDEO"],
      cn: ["项目视频"],
      ru: ["ВИДЕО ПРОЕКТА"],
    },
  },
  {
    titleKey: "interiorTownHomeVideo",
    source: {
      en: `${assetsPath("phuket-laguna-park-2")}/images/gallery/video/2.jpg`,
      ru: `${assetsPath("phuket-laguna-park-2")}/images/gallery/video/2.jpg`,
      cn: `${assetsPath("phuket-laguna-park-2")}/images/gallery/video/2.jpg`,
      // en: `${baseAssetVideoUrl}/Laguna_Park_2_TH_Interior_Video_V.3_17062020.mp4`,
      // cn: `${baseAssetVideoUrl}/Laguna_Park_2_TH_Interior_Video_V.3_17062020.mp4`,
      // ru: `${baseAssetVideoUrl}/Laguna_Park_2_TH_Interior_Video_V.3_17062020.mp4`,
    },
    text: {
      en: ["TOWNHOME"],
      cn: ["联排别墅"],
      ru: ["ТАУНХАУСЫ"],
    },
  },
  {
    titleKey: "interiorVillaVideo",
    source: {
      en: `${assetsPath("phuket-laguna-park-2")}/images/gallery/video/3.jpg`,
      ru: `${assetsPath("phuket-laguna-park-2")}/images/gallery/video/3.jpg`,
      cn: `${assetsPath("phuket-laguna-park-2")}/images/gallery/video/3.jpg`,
      // en: `${baseAssetVideoUrl}/Laguna_Park_2_Villa_Interior_Video_V.3_17062020.mp4`,
      // cn: `${baseAssetVideoUrl}/Laguna_Park_2_Villa_Interior_Video_V.3_17062020.mp4`,
      // ru: `${baseAssetVideoUrl}/Laguna_Park_2_Villa_Interior_Video_V.3_17062020.mp4`,
    },
    text: {
      en: ["SEMI-DETACHED"],
      cn: ["双拼别墅"],
      ru: ["Дуплекс"],
    },
  },
];

const heroShot = [
  { image: heroShotImg1 },
  { image: heroShotImg2 },
  { image: heroShotImg3 },
  { image: heroShotImg4 },
  { image: heroShotImg5 },
  { image: heroShotImg6 },
  { image: heroShotImg7 },
  { image: heroShotImg8 },
  // { image: heroShotImg2_dev },
  // { image: heroShotImg4_dev },
  // { image: heroShotImg5_dev },
];

const categories = [
  {
    id: 1,
    name: "All Images",
  },
  {
    id: 2,
    name: "Residences – Aerial",
  },
  {
    id: 3,
    name: "Residences – Exterior",
  },
  {
    id: 4,
    name: "Residences – Interior",
  },
  {
    id: 5,
    name: "Residences – Common Area",
  },
  {
    id: 6,
    name: "Residences – Lifestyle",
  },
  {
    id: 7,
    name: "Destination Lifestyle",
  },
];

const images = [
  {
    categoryId: 2,
    name: "Aerial – 1",
    image: residencesAerial1,
  },
  {
    categoryId: 2,
    name: "Aerial – 2",
    image: residencesAerial2,
  },
  {
    categoryId: 2,
    name: "Aerial – 3",
    image: residencesAerial3,
  },
  {
    categoryId: 3,
    name: "Building 1",
    image: residencesExterior1,
  },
  {
    categoryId: 3,
    name: "Building 2",
    image: residencesExterior2,
  },
  {
    categoryId: 3,
    name: "Building 3",
    image: residencesExterior3,
  },
  {
    categoryId: 3,
    name: "Building 4",
    image: residencesExterior4,
  },
  {
    categoryId: 4,
    name: "1 Bedroom - Living room",
    image: residencesInterior1,
  },
  {
    categoryId: 4,
    name: "2 Bedroom - Living room",
    image: residencesInterior2,
  },
  {
    categoryId: 4,
    name: "2 Bedroom - Lanai",
    image: residencesInterior3,
  },
  {
    categoryId: 4,
    name: "2 Bedroom - Section",
    image: residencesInterior4,
  },
  {
    categoryId: 4,
    name: "3 Bedroom - Living room",
    image: residencesInterior5,
  },
  {
    categoryId: 4,
    name: "3 Bedroom - Lanai",
    image: residencesInterior6,
  },
  {
    categoryId: 4,
    name: "2 bedroom - garden",
    image: residencesInterior7,
  },
  {
    categoryId: 4,
    name: "3 bedroom - garden",
    image: residencesInterior8,
  },
  {
    categoryId: 5,
    name: "Rooftop Pool",
    image: residencesCommonArea1,
  },
  {
    categoryId: 5,
    name: "Rooftop Facilities",
    image: residencesCommonArea2,
  },
  {
    categoryId: 6,
    name: "Lifestyle",
    image: residencesLifestyle1,
  },
  {
    categoryId: 7,
    name: "destination - 1",
    image: destinationLifestyle1,
  },
  {
    categoryId: 7,
    name: "destination - 2",
    image: destinationLifestyle2,
  },
  {
    categoryId: 7,
    name: "destination - 3",
    image: destinationLifestyle3,
  },
  {
    categoryId: 7,
    name: "destination - 4",
    image: destinationLifestyle4,
  },
  {
    categoryId: 7,
    name: "destination - 5",
    image: destinationLifestyle5,
  },
  {
    categoryId: 7,
    name: "destination - 6",
    image: destinationLifestyle6,
  },
  {
    categoryId: 7,
    name: "destination - 7",
    image: destinationLifestyle7,
  },
];

const image360 = null;

export default {
  heroShot,
  categories,
  images: _.map(images, (image) => {
    return {
      ...image,
      category: _.find(categories, { id: image.categoryId }),
    };
  }),
  video,
  // videos,
  image360,
  view360: [
    {
      id: "AERIAL",
      type: "virtual-tour",
      // src: (
      //   <iframe
      //     width="100%"
      //     height="100%"
      //     src={`${assetsPath(
      //       "laguna-beachside"
      //     )}/images/gallery/virtual-tour/aerial/LBS-Aerial-VTR-Final-20Dec2021.html`}
      //     frameborder="0"
      //     allowfullscreen
      //     allow="vr"
      //   ></iframe>
      // ),
      src: `${assetsPath("laguna-beachside")}/360/aerial/LBS-Aerial.html`,
      // src: `${assetsPath(
      //   "laguna-beachside"
      // )}/images/gallery/virtual-tour/aerial/LBS-Aerial-VTR-Final-20Dec2021.html`,
      list: [],
    },
    {
      id: "INTERIOR",
      type: "virtual-tour",
      src: `${assetsPath("laguna-beachside")}/360/interior/tour.html`,
      // type: "list",
      // src: `${assetsPath(
      //   "laguna-beachside"
      // )}/images/gallery/virtual-tour/1.jpg`,
      // list: [],
    },
    // {
    //   id: 'INTERIOR',
    //   type: 'list',
    //   list: [
    //     {
    //       id: 'VILLA',
    //       target: '_blank',
    //       src: <iframe width='100%' height='100%' src='https://my.matterport.com/show/?m=RzGenJ177tk' frameborder='0' allowfullscreen allow='vr'></iframe>,
    //       href: 'https://my.matterport.com/show/?m=RzGenJ177tk'
    //     },
    //     {
    //       id: 'TOWNHOME',
    //       target: '_blank',
    //       src: <iframe width='100%' height='100%' src='https://my.matterport.com/show/?m=CY6oRgpAriw' frameborder='0' allowfullscreen allow='vr'></iframe>,
    //       href: 'https://my.matterport.com/show/?m=CY6oRgpAriw'
    //     }
    //   ]
    // }
  ],
};



// WEBPACK FOOTER //
// ./src/data/LagunaBeachside/gallery.js